import { RootState } from '../../store';

export const getSettlementSelector = (state: RootState) => state?.settlementReducer?.settlement;
